import { render, staticRenderFns } from "./5.vue?vue&type=template&id=48fac10c&scoped=true&"
import script from "./5.vue?vue&type=script&lang=js&"
export * from "./5.vue?vue&type=script&lang=js&"
import style0 from "./5.vue?vue&type=style&index=0&id=48fac10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fac10c",
  null
  
)

export default component.exports